import { render, staticRenderFns } from "./OrganizationUserSettingsGuard.vue?vue&type=template&id=20179e56&"
import script from "./OrganizationUserSettingsGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserSettingsGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports